<template>
  <div class="pb-1">
    <v-card text tile @contextmenu="selectComponentDEV($event, schema.model)" class="view-master">
      <v-toolbar :class="['master-toolbar elevation-1 pa-2 d-flex justify-end align-center', getSelectedDEV && 'dev-selected-component']">
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon @click.stop="drawer = !drawer" v-on="on" v-ripple="{ center: true }" color="primary" class="mr-2">vertical_split</v-icon>
          </template>
          <span>{{ schema.name }}</span>
        </v-tooltip>

        <i4proBottomSheet title="Opções" :actions="schema.actions" :mode="mode" :page="page" />
      </v-toolbar>
    </v-card>

    <v-navigation-drawer app temporary clipped right hide-overlay v-model="drawer" class="detailDrawer">
      <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
        <div class="drawer-header">
          <div class="drawer-title">{{ schema.name }}</div>
        </div>

        <div class="drawer-body">
          <v-container>
            <v-row v-if="!!fieldsContext() === false">
              <v-col sm="12" xs="12" v-for="(item, index) in handleFilterItems" :key="index">
                <h5>{{ Object.keys(item)[0] }}</h5>
                <p>{{ Object.values(item)[0] }}</p>
              </v-col>
            </v-row>

            <v-form v-model="valid" ref="form" v-if="schema.actions">
              <v-layout row mb-1>
                <vue-form-generator tag="div" :schema="{ fields: schema.fields }" :model="model" :options="{ mode, page }" />
              </v-layout>
            </v-form>
          </v-container>
        </div>
      </vue-perfect-scrollbar>
    </v-navigation-drawer>
  </div>
</template>

<script>
import moment from 'moment';
import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';
import { removeActionsMaster, addActionsMaster } from '@/helpers/dev';

export default {
  mixins: [devComponentMixin],

  components: {
    VuePerfectScrollbar: () => import('vue-perfect-scrollbar'),
    i4proBottomSheet: () => import('@/components/buttons/i4pro-bottom-sheet')
  },

  props: {
    model: { type: Object, default: () => ({}) },
    mode: { type: String, required: true },
    page: { type: String, required: true },
    schema: { type: Object, default: () => ({}) }
  },

  data: () => ({
    drawer: false,
    scrollSettings: {
      maxScrollbarLength: 100
    },
    valid: false
  }),

  events: {
    [HANDLERS.VALIDATE]: 'validate'
  },

  computed: {
    handleFilterItems() {
      return this.schema.headers.reduce((obj, { text, value, type }) => {
        return [...obj, { [text]: type === 'date' ? this.formatDate(this.model[value]) : this.model[value] }];
      }, []);
    }
  },

  mounted() {
    if (this.schema.navigation && !this.schema.actions.slice(-1)[0].navigation) addActionsMaster(this.schema.actions, this.page, this.mode);

    if (!this.schema.navigation) removeActionsMaster(this.schema.actions);
  },

  methods: {
    formatDate: v => moment(v).format('DD/MM/YYYY'),

    fieldsContext() {
      return 'fields' in this.schema;
    },

    validate({ page, mode }) {
      if (mode !== this.mode) return;

      if (!this.valid) this.$refs.form.validate();
    }
  }
};
</script>

<style lang="scss" scoped>
.detailDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    overflow: auto;
    height: 100vh;
  }

  .drawer-header {
    padding: 21px;
    background: var(--v-primary-base);
    border-bottom: 1px solid #e8e8e8;

    .drawer-title {
      margin: 0;
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      color: #fff;
    }
  }

  .drawer-body {
    padding-top: 10px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;

    .row {
      .col {
        padding: 5px 10px;
        border-bottom: 1px solid #dedede;
        &:last-child {
          border-bottom: 0;
        }
      }
    }

    h5 {
      font-weight: 400;
      text-transform: uppercase;
      margin: 0;
    }

    p {
      margin: 0;
      font-size: 13px;
    }
  }
}
</style>
